/* eslint-disable max-lines-per-function */
import { Link } from "@reach/router";
import React from "react";
import moment from "moment";
import { Grid } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import { Button } from "components/haven-design/buttons";

import { WaitlistUpdateRequestStatus as Status, RequestedCounts, RequestedCountsVariables, WaitlistUpdateRequestStatus } from "types/gql-types";
import { ContentProps } from "../types";
import { isBeforeDeadline } from "../utils";
import { REQUESTED_COUNTS } from "../query";
import ManualContact from "./manual-contact";
import { ContentCollapsed } from "./content-collapsed";
import { ContentSection } from "./content-section";

const Content: React.FC<ContentProps> = (props) => {
  const [selectedStatus, setStatus] = React.useState<Status | null>(null);

  const {
    interestList,
    interestList: {
      id: listId,
      scheduledUpdate: { ends },
    },
  } = props;

  const countResults = useQuery<RequestedCounts, RequestedCountsVariables>(
    REQUESTED_COUNTS,
    { variables: {
      id: listId,
      statuses: Object.values(WaitlistUpdateRequestStatus),
    } },
  );

  const deadline = moment.utc(ends);
  const hideProcessRemovals = isBeforeDeadline(deadline);

  return (
    <Grid container spacing={2}>
      <Grid item md={4}>
        <h3>Contact waitlist applicants manually</h3>
        <ManualContact interestList={interestList} countResults={countResults} />
        {!hideProcessRemovals &&
        (<>
          <hr/>
          <h3>Process Removals</h3>
          <div className="margin-top-m">
            <Link to={`/dash/manager/update/${interestList.id}/process/removals`}>
              <Button color="primary" size="S">Process Removals</Button>
            </Link>
          </div></>)}
      </Grid>
      <Grid item md={8}>
        <h3>Results</h3>
        <br/>
        {selectedStatus === null &&
            <ContentCollapsed
              setStatus={setStatus}
              countResults={countResults} />}
        {selectedStatus &&
          <ContentSection
            selectedStatus={selectedStatus}
            setStatus={setStatus}
            interestList={interestList} />}
      </Grid>
    </Grid>
  );
};

export default Content;
